import axios from 'axios';

export default class NoteService {
    fetchNotes(patientId, params = {}) {
        return axios.get(`/v2/patients/${patientId}/notes`, {params});
    }

    saveNote(patientId, note) {
        return axios.post(`/v2/patients/${patientId}/notes`, note);
    }

    deleteNote(patientId, noteId) {
        return axios.delete(`/v2/patients/${patientId}/notes/${noteId}`);
    }

    updateNote(patientId, note) {
        return axios.patch(`/v2/patients/${patientId}/notes/${note.id}`, note);
    }
}
